import { buildModelManager } from "../builder.js";
const DefaultStripePaymentMethodSelection = {
  __typename: true,
  id: true,
  attachedAt: true,
  cardBrand: true,
  cardExpMonth: true,
  cardExpYear: true,
  cardLast4: true,
  createdAt: true,
  detachedAt: true,
  isDefault: true,
  livemode: true,
  profileId: true,
  stripeCustomerId: true,
  stripeId: true,
  type: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "stripePaymentMethod";
const pluralModelApiIdentifier = "stripePaymentMethods";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripePaymentMethodSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripePaymentMethodSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripePaymentMethodSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripePaymentMethodSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripePaymentMethodSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripePaymentMethodSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripePaymentMethodSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByStripeId",
    findByField: "stripeId",
    findByVariableName: "stripeId",
    modelApiIdentifier,
    defaultSelection: DefaultStripePaymentMethodSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByStripeId",
    findByField: "stripeId",
    findByVariableName: "stripeId",
    modelApiIdentifier,
    defaultSelection: DefaultStripePaymentMethodSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "stripePaymentMethodGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const StripePaymentMethodManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultStripePaymentMethodSelection,
  operations
);
export {
  DefaultStripePaymentMethodSelection,
  StripePaymentMethodManager
};
//# sourceMappingURL=StripePaymentMethod.js.map
